import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-list-technical',
  templateUrl: './list-technical.component.html',
  styleUrls: ['../../app.component.css', './list-technical.component.css']
})

export class ListTechnicalComponent {

  // @Input() list;
  //
  // constructor(
  //   private _sanitizer: DomSanitizer
  // ) { }
  //
  // getUrl(video) {
  //   let url = video.split("watch?v=");
  //   return this._sanitizer.bypassSecurityTrustResourceUrl("http://img.youtube.com/vi/"+url[1]+"/mqdefault.jpg");
  // }

}



// WEBPACK FOOTER //
// ./src/app/shared/list-technical/list-technical.component.ts